<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-12-19 14:56:38
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2021-01-21 10:23:54
 -->
<template>
  <div id="app" class="wh100">
    <transition :name="transitionName" v-if="isRouterAlive">
      <router-view class="Router"></router-view>
    </transition>
  </div>
</template>
 
<script>
export default {
  name: 'App',
  provide(){
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      transitionName: 'slideleft',
      isRouterAlive: true,
    }
  },
  created() {
      this.resize(document, window);
      this.loader();
  },
  methods:{
    reload(){
      this.isRouterAlive = false;
      this.$nextTick(()=>{
        this.isRouterAlive = true;
      });
    },
    /*设置rem参照单位。width：1rem = 50px 所以设计稿宽 375px == 375/50 = 7.5rem
      * 由于页面中有些元素用了绝对定位。特别是top，bottom。由于设备不同，计算出的rem不同，
      * 导致定位覆盖。所以，建议涉及高度的 统一用 px 做单位，包括padding-top,bottom等。
      * 因为高度存在滚动条，不存在适配问题。主要针对宽度做适配。
      *
      * */
    resize(doc, win) {
      var docEl = doc.documentElement,
        resizeEvt = "orientationchange" in window ? "orientationchange" : "resize",
        recalc = function() {
          var clientWidth = docEl.clientWidth;
          if(!clientWidth) {clientWidth = doc.body.clientWidth;}
          if(clientWidth>=750) {
          docEl.style.fontSize = "100px"
          }else{
          docEl.style.fontSize = 100*(clientWidth/750)+"px"
          } 
          //处理安卓某些设备rem不兼容；
        //  remFlexible(win, docEl);
        };
        if(!doc.addEventListener) {return}
        win.addEventListener(resizeEvt, recalc, false);
        doc.addEventListener("DOMContentLoaded", recalc, false);
    },
    remFlexible(win, docEl){
      var ua = navigator.userAgent;
          var isIOS = /(iPhone|iPad|iPod)/.test(ua);
          // 非苹果设备，均进行检测
          if (!isIOS) {
              var div = document.createElement('div');
              div.style.width = '7.5rem';
              document.body.appendChild(div);
              setTimeout(function () {
                  var getWidth = parseFloat(win.getComputedStyle ? win.getComputedStyle(div, null).width : div.currentStyle.width),
                  screenW = win.screen.width;
                  if (getWidth > screenW) {
                      // 此时是出问题的情况
                      var ratio = getWidth / screenW;
                      docEl.style.fontSize = ((screenW/7.5) / ratio).toFixed(4) + 'px';
                  }
                  document.body.removeChild(div);
              }, 100);
          }
    },
    //解决ios不能禁止缩放
    loader(){
      window.onload = function() {
          // 阻止双击放大
          var lastTouchEnd = 0;
          document.addEventListener('touchstart', function(event) {
              if (event.touches.length > 1) {
                  event.preventDefault();
              }
          });
          document.addEventListener('touchend', function(event) {
              var now = (new Date()).getTime();
              if (now - lastTouchEnd <= 300) {
                  event.preventDefault();
              }
              lastTouchEnd = now;
          }, false);

          // 阻止双指放大
          document.addEventListener('gesturestart', function(event) {
              event.preventDefault();
          });
      }
    }
  },
  watch: {
    $route() {   // 监听路由变化重新赋值
      if (this.$router.isleft) {
        this.transitionName = 'slideleft'
      }
      if (this.$router.isright) {
        this.transitionName = 'slideright'
      }
    }
  }
}
</script>

<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2e2e2e;
  -webkit-tap-highlight-color:rgba(0,0,0,0);//ios兼容
  font-size: 0.28rem;
}
.slideleft-enter,
 .slideright-leave-active {
  opacity: 0;
  -webkit-transform: translate(100%, 0);
  transform: translate(100%, 0);
}
.slideleft-leave-active,
.slideright-enter {
  opacity: 0;
  -webkit-transform: translate(-100%, 0);
  transform: translate(-100%, 0);
}
</style>


// WEBPACK FOOTER //
// src/App.vue